var map = {
	"./5_CC Punkte Violine.jpg": 2684,
	"./cremona.jpg": 1000,
	"./image1.PNG": 5124,
	"./image3.jpg": 6421,
	"./jebony.jpg": 7946,
	"./kaufen_leihen.jpg": 2507,
	"./reparatur.jpeg": 8162,
	"./shanghai.jpg": 3652,
	"./slider1.jpg": 5351,
	"./slider3.jpg": 2037,
	"./slider4.jpg": 4702,
	"./slider5.jpg": 6011,
	"./technik.jpeg": 1046
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5489;
module.exports = webpackAsyncContext;